<template>
  <wsp-modal>
    <v-card class="pb-5" flat>
      <v-card-title class="pa-0">
        <v-toolbar class="primary" dark dense flat>
          <v-toolbar-title>
            {{ $t('global.buy.modal.title') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="visible = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <payment-internal
          :product="product"
          :coupon-code="product.couponCode"
          :openAutomatically="openAutomatically"
        ></payment-internal>
      </v-card-text>
      <v-card-actions> </v-card-actions>
    </v-card>
  </wsp-modal>
</template>

<script>
import WspModal from '@/components/commons/WspModal';
import PaymentInternal from '@/components/commons/PaymentInternal';

export default {
  name: 'PaymentGateway',
  props: {
    product: {
      type: Object,
      default: null,
    },
    openAutomatically: {
      type: Boolean,
      deafult: false,
    },
  },
  components: {
    [WspModal.name]: WspModal,
    [PaymentInternal.name]: PaymentInternal,
  },
  watch: {
    visible: function (value) {
      if (!value) {
        this.$emit('on-close', {});
      }
    },
  },
  data() {
    return {
      visible: true,
    };
  },
  created() {},

  methods: {},
};
</script>
